// extracted by mini-css-extract-plugin
module.exports = {"figure":"style-module--figure--1EPAf","teaserImageWrapper":"style-module--teaserImageWrapper--3wYfw"};